import React from "react";
import moment from "moment";
import { getFileIconClass } from "../../constants/general.constant";

const EducationMaterialDetails = ({ educationMaterials }) => {
  if (!educationMaterials || educationMaterials.length === 0) return null;

  return (
    <div>
      <hr style={{ borderTop: "3px solid #5c5959" }} />
      <table className="table table-bordered page-break-ka-after mb-4 scrollbar-table-cls">
        <thead>
          <tr>
            <th colSpan="5" className="text-center text-dark">
              <h3 className="font-weight-bold">
                Educational Materials Provided
              </h3>
            </th>
          </tr>
          <tr>
            <th className="text-center">Material Type</th>
            <th className="text-center">Message</th>
            <th className="text-center">Educational Material Documents/Link</th>
            <th className="text-center">Provided By</th>
            <th className="text-center">Date</th>
          </tr>
        </thead>
        <tbody className="text-center">
          {educationMaterials.map((material, index) => (
            <tr key={index}>
              <td>
                {material.educationMaterialType
                  ? material.educationMaterialType.materialType
                  : "-"}
              </td>
              <td>{material.message}</td>
              <td>
                {material.files && material.files.length > 0 && (
                  <div>
                    <h5 className="text-left">Educational Documents</h5>
                    {material.files.map((item, idx) => {
                      const { icon, color } = getFileIconClass(item.name);

                      return (
                        <div key={idx} className="link-hover">
                          <a
                            href={
                              process.env.REACT_APP_VIDEO_CALL_REQUEST +
                              "/" +
                              item.path
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: "none" }}
                          >
                            <p style={{ display: "flex", alignItems: "center" }}>
                              <i
                                className={icon}
                                style={{ fontSize: 20, color, marginRight: 6 }}
                              ></i>
                              <span
                                style={{
                                  color: "#000000",
                                  textDecoration: "underline",
                                  fontWeight: 200,
                                  display: "inline-block",
                                  maxWidth: "350px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                                title={item.name}
                              >
                                {item.name}
                              </span>
                            </p>
                          </a>
                        </div>)
                    }
                    )}
                  </div>
                )}
                {material.materialLink && material.materialLink.length > 0 && (
                  <div>
                    <h5 className="text-left">Educational Material Link</h5>
                    {material.materialLink.map((item, idx) => (
                      <div key={idx} className="link-hover">
                        <a
                          href={item}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ textDecoration: "none" }}
                        >
                          <p style={{ display: "flex", alignItems: "center" }}>
                            <i
                              className="mdi mdi-link mr-2"
                              style={{
                                fontSize: 20,
                                color: "blue",
                                marginRight: 6,
                              }}
                            ></i>
                            <span
                              style={{
                                color: "#000000",
                                textDecoration: "underline",
                                fontWeight: 200,
                                display: "inline-block",
                                maxWidth: "350px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                              title={item}
                            >
                              {item}
                            </span>
                          </p>
                        </a>
                      </div>
                    ))}
                  </div>
                )}
              </td>
              <td>
                {material.sender
                  ? material.sender.fname + " " + material.sender.lname
                  : "-"}
              </td>
              <td>{moment(material.createdAt).format("MM/DD/YYYY")}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default EducationMaterialDetails;